// extracted by mini-css-extract-plugin
module.exports = {"langSwitcher":"LanguageSwitcher_langSwitcher__iUzdh","langSwitcherButton":"LanguageSwitcher_langSwitcherButton__1BgTE","tickIcon":"LanguageSwitcher_tickIcon__2SSfJ"};